<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptDefault :attribute="attribute" :currentCpt="currentCpt" />
    <t-form-item label="日期/时间范围">
      <t-switch v-model="attribute.daterange" />
    </t-form-item>
    <t-form-item label="日期/时间格式">
      <t-select
        v-model="attribute.dateFormat"
        size="small"
        @change="handleChange"
      >
        <t-option
          v-for="(item, index) in defaultTypeArray"
          :key="index"
          :label="item.label"
          :value="item.type"
        />
      </t-select>
    </t-form-item>
    <CptInputOptionBase
      :attribute="attribute"
      :currentCpt="currentCpt"
      @changeSize="changeSize"
    />
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptDefault from "@/components/element/options/comp/cpt-default";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-date-picker-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptDefault, CptInputOptionBase, CptData },
  data() {
    return {
      defaultTypeArray: [
        {
          type: "year",
          label: "年(YYYY)",
        },
        {
          type: "month",
          label: "年月(YYYY-MM)",
        },
        {
          type: "date",
          label: "年月日(YYYY-MM-DD)",
        },
        {
          type: "datetime",
          label: "年月日(YYYY-MM-DD hh:mm:ss)",
        },
        {
          type: "HH",
          label: "时",
        },
        {
          type: "HH:mm",
          label: "时分",
        },
        {
          type: "HH:mm:ss",
          label: "时分秒",
        },
      ],
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 24 },
        medium: { width: this.currentCpt.cptWidth, height: 32 },
        large: { width: this.currentCpt.cptWidth, height: 40 },
      },
    };
  },
  mounted() {
    //  console.log(this.currentCpt,'attribute')
  },
  methods: {
    handleChange(event) {
      // this.attribute.dateFormat = event;
      console.log("选中的值为：", event);
    },
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>

<style scoped></style>
